export const createConfig = (method = 'GET', payload = {}, options = {}) => {
  const config = {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json;;charset=utf-8',
      'Content-Type': 'application/json;charset=utf-8',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      'Greenmile-Module': 'LIVE',
      'Greenmile-Version': App.Version.GMLVersionNumber,
      'Greenmile-Build': App.Version.GMLBuildNumber
    },
    ...options
  };

  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    config.body = JSON.stringify(payload);
  }

  return config;
};

export const validateFetch = async (response) => {
  const result = {};
  const monetError = {
    status: response.status || 500,
    responseText: response.statusText || response.message
  };

  try {
    result.error = await response.json();
    result.status = response.status;
  } catch (err) {
    result.error = monetError;
  }
  return result;
};

function defaultFetch(
  url,
  payload = {},
  method = 'GET',
  formatAsJSON = true,
  options = null
) {
  return fetch(url.replace(/#/g, '%23'), createConfig(method, payload, options))
    .then((response) => {
      if (response.status >= 400) {
        return validateFetch(response);
      }
      return formatAsJSON ? response.json() : response;
    })
    .catch((error) => ({ error }));
}
export default defaultFetch;
